import { render, staticRenderFns } from "./ExpressWelcomeTheme.vue?vue&type=template&id=2f863d31&scoped=true"
import script from "./ExpressWelcomeTheme.vue?vue&type=script&lang=js"
export * from "./ExpressWelcomeTheme.vue?vue&type=script&lang=js"
import style0 from "./ExpressWelcomeTheme.vue?vue&type=style&index=0&id=2f863d31&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f863d31",
  null
  
)

export default component.exports